import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full border-b border-line bg-ink px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="faq-title" data-id="element-66" data-mp="1gitxk8ygb4lu">
      <div className="mx-auto max-w-3xl" data-id="element-67" data-mp="249zlzcigj57r">
        <SectionHeading eyebrow="❓" title="Lo que más nos preguntan" data-id="element-68" data-mp="28ajicdv7i4su" />

        <ul className="mt-10 space-y-3" data-id="element-69" data-mp="28cw12t8sgj6y">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="overflow-hidden rounded-2xl border border-line bg-surface" data-id="element-70" data-mp="1zhfxvlm58rop" data-mpi={index}>
                <h3 data-id="element-71" data-mp="2n67ls0spanvo">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-72" data-mp="2rzag4b5ay1cx">
                    <span className="text-sm font-bold text-white sm:text-base" data-id="element-73" data-mp="19tc3h744y4pg">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-74" data-mp="1oldwc77sfxfz" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-75" data-mp="35yh7ktg4vi9">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeOut'
              }} data-id="element-76" data-mp="3816g2mryklx">
                      <p className="border-t border-line px-5 py-5 text-sm leading-relaxed text-neutral-400" data-id="element-77" data-mp="28713ixjxmizs">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}